import React, { useEffect, useState } from 'react';
import { Alert, Button, Input, Modal, Tooltip } from 'antd';
import { CommentOutlined, PlusOutlined } from '@ant-design/icons';
import { cartOrderNotesKey, readCartOrderNotes, saveCartOrderNote } from '../utils/cartOrderNotes';

const CartTaskNoteButton = ({ propertyId, propertyTitle }) => {
  const storageKey = cartOrderNotesKey();
  const [open, setOpen] = useState(false);
  const [savedNote, setSavedNote] = useState('');
  const [draft, setDraft] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    setSavedNote(readCartOrderNotes([propertyId], storageKey)[propertyId] || '');
    setDraft('');
    setOpen(false);
    setError(null);
  }, [propertyId, storageKey]);

  const show = () => {
    const note = readCartOrderNotes([propertyId], storageKey)[propertyId] || '';
    setDraft(note);
    setError(null);
    setOpen(true);
  };

  const save = () => {
    if (storageKey !== cartOrderNotesKey() || !saveCartOrderNote(propertyId, draft, storageKey)) {
      setError('The note could not be saved in this tab. Reopen it and try again.');
      return;
    }
    setSavedNote(readCartOrderNotes([propertyId], storageKey)[propertyId] || '');
    setOpen(false);
  };

  return <>
    <Tooltip title={savedNote ? 'Edit task note' : 'Add task note'}>
      <Button type="text" aria-label={`${savedNote ? 'Edit' : 'Add'} task note for ${propertyTitle || propertyId}`}
        onClick={show} className={savedNote ? 'text-blue-600' : 'text-golden-navy'}
        icon={<span className="relative inline-flex"><CommentOutlined />{!savedNote && <PlusOutlined className="absolute -right-1 -top-1 text-[8px]" />}</span>} />
    </Tooltip>
    <Modal title={<span className="block break-words pr-8">Task note — {propertyTitle || propertyId}</span>} open={open} onCancel={() => setOpen(false)}
      onOk={save} okText="Save note" width={560}>
      <p className="mb-3 text-sm text-gray-600">For this delivery only. The driver and assigned cleaners can read this note after checkout.</p>
      {error && <Alert type="error" showIcon message={error} className="mb-3" />}
      <label htmlFor={`cart-task-note-${propertyId}`} className="mb-1 block text-sm font-medium">Task note</label>
      <div className="pb-6">
        <Input.TextArea id={`cart-task-note-${propertyId}`} rows={5} maxLength={2000} showCount value={draft}
          onChange={event => setDraft(event.target.value)} />
      </div>
    </Modal>
  </>;
};

export default CartTaskNoteButton;
